export default __webpack_public_path__ + "static/media/526.db30af19.jpg";